export enum Cookie {
  AccessToken = "credentials.access_token",
  CouponCode = "discount",
  Scopes = "credentials.scopes",
  PartnerId = "partner_id",
  UtmSource = "utm_source",
  UtmMedium = "utm_medium",
  UtmCampaign = "utm_campaign",
  UtmTerm = "utm_term",
  UtmContent = "utm_content",
  Referrer = "referrer",
  LandingPage = "landing_page",
  SourceURL = "source_url",
  SourceID = "source_id",
  SourceType = "source_type",
}
